"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlendingEventDispatcher = void 0;
const logger_1 = require("../../../../logger");
class BlendingEventDispatcher {
    constructor() {
        this.subscriptions = new Array();
        this.logger = logger_1.logger;
    }
    subscribe(fn) {
        if (fn && this.subscriptions.indexOf(fn) < 0) {
            this.subscriptions.push(fn);
        }
    }
    unsubscribe(fn) {
        const i = this.subscriptions.indexOf(fn);
        if (i >= 0) {
            this.subscriptions.splice(i, 1);
        }
    }
    unsubscribeAll() {
        this.subscriptions.length = 0;
    }
    dispatch(sender, args) {
        for (const handler of [...this.subscriptions]) {
            try {
                handler(sender, args);
            }
            catch (ex) {
                // Unhandled exception occurs from handler
                logger_1.logger.error(`${ex.message}\n${ex.stack}`);
            }
        }
    }
}
exports.BlendingEventDispatcher = BlendingEventDispatcher;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmxlbmRpbmctZXZlbnQtZGlzcGF0Y2hlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2hpc3RvcmljYWwtcHJpY2luZy90aW1lLXNlcmllcy9ibGVuZGluZy9ibGVuZGluZy1ldmVudC1kaXNwYXRjaGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLCtDQUFvRDtBQUVwRCxNQUFhLHVCQUF1QjtJQUdoQztRQUlRLGtCQUFhLEdBQWtELElBQUksS0FBSyxFQUEwQyxDQUFDO1FBSHZILElBQUksQ0FBQyxNQUFNLEdBQUcsZUFBTSxDQUFDO0lBQ3pCLENBQUM7SUFJTSxTQUFTLENBQUMsRUFBMEM7UUFDdkQsSUFBSSxFQUFFLElBQUksSUFBSSxDQUFDLGFBQWEsQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUM7WUFDM0MsSUFBSSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7UUFDaEMsQ0FBQztJQUNMLENBQUM7SUFFTSxXQUFXLENBQUMsRUFBMEM7UUFDekQsTUFBTSxDQUFDLEdBQUcsSUFBSSxDQUFDLGFBQWEsQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLENBQUM7UUFDekMsSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUM7WUFDVCxJQUFJLENBQUMsYUFBYSxDQUFDLE1BQU0sQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUM7UUFDcEMsQ0FBQztJQUNMLENBQUM7SUFFTSxjQUFjO1FBQ2pCLElBQUksQ0FBQyxhQUFhLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQztJQUNsQyxDQUFDO0lBRU0sUUFBUSxDQUFDLE1BQWUsRUFBRSxJQUFXO1FBQ3hDLEtBQUssTUFBTSxPQUFPLElBQUksQ0FBQyxHQUFHLElBQUksQ0FBQyxhQUFhLENBQUMsRUFBRSxDQUFDO1lBQzVDLElBQUksQ0FBQztnQkFDRCxPQUFPLENBQUMsTUFBTSxFQUFFLElBQUksQ0FBQyxDQUFDO1lBQzFCLENBQUM7WUFBQyxPQUFPLEVBQUUsRUFBRSxDQUFDO2dCQUNWLDBDQUEwQztnQkFDMUMsZUFBTSxDQUFDLEtBQUssQ0FBQyxHQUFHLEVBQUUsQ0FBQyxPQUFPLEtBQUssRUFBRSxDQUFDLEtBQUssRUFBRSxDQUFDLENBQUM7WUFDL0MsQ0FBQztRQUNMLENBQUM7SUFDTCxDQUFDO0NBQ0o7QUFwQ0QsMERBb0NDIn0=